<!--  * @Author: qinkexin  * @Date: 2025-01-06 13:37:23  * @LastEditors: qinkexin  * @LastEditTime: 2025-02-21 14:18:08  * @Descripttion:  --> <template>   
<div class="select" :class="num">     <!-- <label class="label" :style="{ width: labelWidth }">{{ label }}</label> -->     <label class="label">{{ label }}</label>     
<el-select autoId="select_selectVal" v-model="selectVal" class="el-select" size="small" :placeholder="placeholder" clearable :disabled="disabled">        
<el-option v-for="dict in list" :key="dict.id" :label="dict[selectField.label]" :value="dict[selectField.value]" />     
</el-select>   
</div> </template>
<script>
export default {
  props: {
    /* 编辑器的内容 */
    list: {
      type: Array,
      default: () => []
    },
    value: {
      type: [String,Number],
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    labelWidth: {
      type: String,
      default: '60px'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    selectField: {
      type: Object,
      default: () => {
        return { label: 'label', value: 'value' }
      }
    }
  },
  data() {
    return {
      selectVal: this.value,
      num: 'select' + Math.random().toString().split('.')[1]
    }
  },
  watch: {
    value(val) {
      this.selectVal = val
    },
    selectVal(val) {
      this.$emit('input', val)
    }
  },
  mounted() {
    const element = document.querySelector(`.${this.num}`)
    element.style.setProperty('--selectleft', `${this.labelWidth.split('px')[0] * 1 + 12}px`)
    element.style.setProperty('--selectpadding', `${this.labelWidth.split('px')[0] * 1 + 36}px`)
  }
}
</script>
<style lang="scss" scoped>
.select {
  --selectleft: 60px;
  --selectpadding: 72px;
  position: relative;
  width: 100%;
  display: flex;
  label {
    position: absolute;
    z-index: 1;
    margin: 0 12px;
    left: 0;
    height: 32px;
    // top: -2px;
    width: var(--selectleft);
    display: inline-block;
    text-align: center;
    font-size: 14px;
    color: #333333;
    letter-spacing: 0;
    text-align: center;
    font-weight: 400;
    line-height: 32px;
  }
  .el-select {
    flex: 1;
    :deep(.el-input__inner) {
      padding-left: var(--selectpadding);
      border: 1px solid #dcdfe6;
    }
  }
}
</style>
